import React from 'react';

const TooltipIcon = () => {
  return (
    <svg
      width='10'
      height='10'
      viewBox='0 0 10 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_10795_24609)'>
        <path
          d='M5.0026 6.66683V5.00016M5.0026 3.3335H5.00677M9.16927 5.00016C9.16927 7.30135 7.30379 9.16683 5.0026 9.16683C2.70142 9.16683 0.835938 7.30135 0.835938 5.00016C0.835938 2.69898 2.70142 0.833496 5.0026 0.833496C7.30379 0.833496 9.16927 2.69898 9.16927 5.00016Z'
          stroke='#6B7280'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_10795_24609'>
          <rect width='10' height='10' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TooltipIcon;
